import { Canceler } from 'axios';
import { request, safeRequest } from '@synergy/api';

import { PurchaseOrder } from '../models/purchase-order';

export class PurchaseOrdersApi {
    constructor(protected baseUrl: string) {}

    private canceler: Canceler | undefined;

    public cget = (params?: URLSearchParams) => {
        this.canceler?.();

        return safeRequest(
            () => request.get(`${this.baseUrl}/purchase-orders`, { params }),
            response => {
                response.data.items = response.data.items.map(PurchaseOrder.fromPlainObject);
                return response.data;
            }
        );
    };
}
